import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckSquare, faMinusSquare, faSquare } from "@fortawesome/free-regular-svg-icons";
import { faCaretLeft, faCheck, faFolder, faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BLink, BModal, BPagination, BSpinner, BTable } from "bootstrap-vue";
import { computed, ref, watch } from "vue";
import { SELECTION_STATES } from "@/components/SelectionDialog/selectionTypes";
import DataDialogSearch from "@/components/SelectionDialog/DataDialogSearch.vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectionDialog',
    props: {
        disableOk: { type: Boolean, default: false },
        errorMessage: { default: "" },
        fileMode: { type: Boolean, default: true },
        fields: { default: () => [] },
        isBusy: { type: Boolean, default: false },
        isEncoded: { type: Boolean, default: false },
        items: { default: () => [] },
        itemsProvider: { default: undefined },
        providerUrl: { default: undefined },
        totalItems: { default: 0 },
        leafIcon: { default: "fa fa-file-o" },
        modalShow: { type: Boolean, default: true },
        modalStatic: { type: Boolean, default: false },
        multiple: { type: Boolean, default: false },
        optionsShow: { type: Boolean, default: false },
        undoShow: { type: Boolean, default: false },
        selectAllIcon: { default: SELECTION_STATES.UNSELECTED },
        showSelectIcon: { type: Boolean, default: false },
        title: { default: "" }
    },
    emits: ["onCancel", "onClick", "onOk", "onOpen", "onSelectAll", "onUndo"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCaretLeft, faCheck, faCheckSquare, faFolder, faMinusSquare, faSpinner, faSquare, faTimes);
        const LABEL_FIELD = { key: "label", sortable: true };
        const SELECT_ICON_FIELD = { key: "__select_icon__", label: "", sortable: false };
        const filter = ref("");
        const currentPage = ref(1);
        const perPage = ref(25);
        const fieldDetails = computed(() => {
            const fields = props.fields.slice().map((x) => {
                x.sortable = x.sortable === undefined ? true : x.sortable;
                return x;
            });
            if (fields.length === 0) {
                fields.unshift(LABEL_FIELD);
            }
            if (props.showSelectIcon) {
                fields.unshift(SELECT_ICON_FIELD);
            }
            return fields;
        });
        function selectionIcon(variant) {
            switch (variant) {
                case SELECTION_STATES.SELECTED:
                    return faCheckSquare;
                case SELECTION_STATES.MIXED:
                    return faMinusSquare;
                default:
                    return faSquare;
            }
        }
        /** Resets pagination when a filter/search word is entered **/
        function filtered(items) {
            if (props.itemsProvider === undefined) {
                currentPage.value = 1;
            }
        }
        /** Format time stamp */
        function formatTime(value) {
            if (value) {
                const date = new Date(value);
                return date.toLocaleString("default", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                    minute: "numeric",
                    hour: "numeric",
                });
            }
            else {
                return "-";
            }
        }
        watch(() => props.items, () => {
            filtered(props.items);
        });
        watch(() => props.providerUrl, () => {
            // We need to reset the current page when drilling down sub-folders
            if (props.itemsProvider !== undefined) {
                currentPage.value = 1;
            }
        });
        return { __sfc: true, LABEL_FIELD, SELECT_ICON_FIELD, props, emit, filter, currentPage, perPage, fieldDetails, selectionIcon, filtered, formatTime, faCaretLeft, faCheck, faFolder, faSpinner, faTimes, FontAwesomeIcon, BAlert, BButton, BLink, BModal, BPagination, BSpinner, BTable, DataDialogSearch, StatelessTags };
    }
});
